<template>
  <v-container fluid class="pl-0">
    <v-row v-if="files.length">
      <v-col cols="12" xs="6" sm="4" md="3" lg="2" class="pl-0" v-for="(file, index) in files" :key="index">
        <card-file
            :file="file"
            :uri="uri"
            :habilitar-exclusao="habilitarExclusao"
            @CardFile_remove="arquivoRemovido">
        </card-file>
      </v-col>
    </v-row>
    <v-row justify="center" v-if="!files.length">
      {{ $t('label.tabela_sem_anexo') }}
    </v-row>
  </v-container>
</template>

<script>
import CardFile from './CardFile';

export default {
  name: 'ListFiles',
  components: { CardFile },
  props: {
    uri: '',
    habilitarExclusao: {
      type: Boolean,
      default: false,
    },
    tipoDocumento: {
      type: Number,
      default: null,
    },
    habilitarTipoArquivo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      files: [],
    };
  },
  watch: {
    possuiArquivos(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('ListFiles_ITENS_ALTERADOS', newValue);
      }
    },
  },
  computed: {
    possuiArquivos() {
      return !!(this.files && this.files.length);
    },
  },
  methods: {
    buscarDoc(request, callback, turn = 1) {
      request.then((response) => {
        this.files = response.body;
        if (this.files.length === 0 && turn === 0) {
          throw new Error();
        }
        this.$emit('ListFiles__arquivos', this.files);
        if (callback) {
          callback();
        }
      }).catch(() => {
        if (turn === 0) {
          this.buscarDoc(this.$http.get(`${this.uri.split('apuracao')[0].replace(/\/$/, '')}/list`), callback, 1);
        }
      });
    },
    carregarArquivos(callback) {
      let request;
      if (this.tipoDocumento === 0 || this.habilitarTipoArquivo) {
        request = this.$http.get(`${this.uri}/tipo-documento/${this.tipoDocumento}/list`);
      } else {
        request = this.$http.get(`${this.uri}/list`);
      }
      this.buscarDoc(request, callback, 0);
    },
    refresh(callback) {
      this.files = [];
      setTimeout(() => this.carregarArquivos(callback), 1E2);
    },
    arquivoRemovido() {
      this.$emit('ListFiles__arquivoRemovido');
      this.refresh();
    },
  },
  mounted() {
    this.carregarArquivos();
  },
};
</script>

<style scoped>

</style>
